export interface TranscriptionDedupMessage {
  id?: unknown;
  text?: unknown;
  final?: unknown;
  isFinal?: unknown;
}

function isFinalMessage(message: TranscriptionDedupMessage): boolean {
  return message.isFinal === true || message.final === true;
}

export function normalizeTranscriptionTextForComparison(value: unknown): string {
  return String(value ?? "")
    .normalize("NFKC")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function canUsePartialTranscriptMatch(text: string): boolean {
  const wordCount = text.split(" ").filter(Boolean).length;
  return text.length >= 16 || (text.length >= 8 && wordCount >= 2);
}

export function transcriptionTextsLikelyOverlap(a: unknown, b: unknown): boolean {
  const left = normalizeTranscriptionTextForComparison(a);
  const right = normalizeTranscriptionTextForComparison(b);

  if (!left || !right) return false;
  if (left === right) return true;

  const [shorter, longer] = left.length <= right.length ? [left, right] : [right, left];

  if (!canUsePartialTranscriptMatch(shorter)) return false;

  return longer.startsWith(shorter) || longer.includes(shorter);
}

export function hasLikelyDuplicateTranscription(
  candidate: TranscriptionDedupMessage,
  existingMessages: TranscriptionDedupMessage[]
): boolean {
  const candidateId = String(candidate.id || "");

  return existingMessages.some((existing) => {
    if (candidateId && String(existing.id || "") === candidateId) {
      return true;
    }

    if (isFinalMessage(candidate) && isFinalMessage(existing)) {
      return (
        normalizeTranscriptionTextForComparison(candidate.text) ===
        normalizeTranscriptionTextForComparison(existing.text)
      );
    }

    return transcriptionTextsLikelyOverlap(candidate.text, existing.text);
  });
}
